// Core
import React from "react";

// Styles
import "./styles.scss";

// Svg
import filterIcon from "../../Assets/Images/filterIcon.svg";

const Button = ({
  title = "Button",
  buttonStyle = {},
  titleStyle = {},
  onClick = () => {},
  forForm = false,
  forFormBtnType = "submit",
  disabled = false,
  ariaLabel = "Button",
  outlineButton,
  isFilter,
  className,
  modifyClassName,
}) => {
  // Determine the button's element based on the forForm prop
  const Element = forForm ? "button" : "div";

  return (
    <Element
      type={forForm ? forFormBtnType : undefined}
      className={`button ${disabled ? "button--disabled" : ""}${
        outlineButton ? "outline-button" : ""
      } ${modifyClassName ? className : ""}`}
      style={buttonStyle}
      onClick={disabled ? undefined : onClick}
      role="button"
      aria-pressed={forForm ? "false" : undefined}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      <div
        className={outlineButton ? "outlineTitle" : "title"}
        style={titleStyle}
      >
        {isFilter ? (
          <img
            src={filterIcon}
            alt="filter"
            className="me-2 mb-1"
            width={24}
            height={24}
          />
        ) : (
          ""
        )}
        {title}
      </div>
    </Element>
  );
};

export default Button;
